import { CustomerRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

class GeneralInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      customer: {}
    };
  }

  unmaskField(value) {
    return !!value ? value.replace(/\D/g, "") : "";
  }

  loadingStatus(value) {
    this.enqueue({ loading: value });
  }

  async onIdentificationChangeCnpj(cnpj) {
    if (cnpj.length === 14) {
      this.loadingStatus(true);
      const response = await CustomerRepository.getCnpjInfo(cnpj);
      if (response.success) {
        const { customer } = this.props;

        customer.email = response.email;
        customer.name = response.tradingName;
        customer.address = {
          ...customer.address,
          zipcode: response.zipcode,
          complement: response.addressAdditional,
          state: response.state,
          street: response.address,
          neighborhood: response.neighborhood,
          city: response.city,
          number: response.addressNumber
        };

        if (response.phone) {
          customer.phone = response.phone;
        }
      }
      this.loadingStatus(false);
    }
  }
}

export default GeneralInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/general-info/presenter.js